export default {
  mathTitle: "جواب را وارد کنید:",
  regularTitle: "کد امنیتی را وارد کنید"
};
